import { withChartLayout } from 'components/common';
import DischargeSummaryScreen from 'components/features/chart/admission-history/discharge-summary/DischargeSummaryScreen';

const DischargeSummaryScreenPage = withChartLayout('Discharge Summary')(DischargeSummaryScreen);
export default DischargeSummaryScreenPage;
